/**
 * MSG-7: did браузерного устройства владельца (модель MSG-3: access-JWT +
 * X-Device-Id). Форма — lowercase UUID, как did AND-2 у телефона.
 *
 * did живёт в localStorage РЯДОМ с криптостором IndexedDB и обязан меняться
 * только вместе с ним: очистка site data сносит оба разом -> браузер честно
 * становится НОВЫМ устройством с новым identity (модель §2.1 — как
 * переустановка приложения). Отдельного «восстановления» нет по построению.
 */
const KEY = 'msg_device_id';

export function browserDeviceId() {
  let did = localStorage.getItem(KEY);
  if (!did || !/^[0-9a-f-]{36}$/.test(did)) {
    did = globalThis.crypto.randomUUID();
    localStorage.setItem(KEY, did);
  }
  return did;
}

/**
 * Д-20: сделать этот браузер НОВЫМ устройством — по явному «перенести сюда».
 *
 * 🔴 Ревокнутый did выжжен на сервере навсегда (`register_device`: старый
 * device-JWT живёт до 90 дней, и переиспользование did означало бы захват
 * канала). Значит вернуться прежним did нельзя по построению: перенос
 * обязан завести новый — и вместе с ним новый криптостор
 * (`storeNameFor(principal, did)`), то есть расшифрованная история в ЭТОМ
 * браузере начнётся с чистого листа. Кнопка, которая это вызывает, обязана
 * говорить о цене прямо.
 */
export function rotateBrowserDeviceId() {
  const did = globalThis.crypto.randomUUID();
  localStorage.setItem(KEY, did);
  return did;
}
